module.exports = __webpack_public_path__ + "static/media/seasonal_flat_white.5faf23b6.svg";